import { x } from '../../utils';
import loggerFactory from '../../logger';
const log = loggerFactory.get('repository:gc');

function Context() {
    this.removedItems = [];
    this.removedSize = 0;
}

Context.prototype.remove = function (items) {
    while (items.length > 0) {
        this.removeItem(items.shift());
    }
};

Context.prototype.removeItem = function (item) {
    if (item.remove()) {
        this.removedSize += item.size;
        this.removedItems.push(x.pick(item, 'collection', 'identifier', 'size'));
    }
};

function GarbageCollector() {
    // Items is an array of garbage collectable data items
    this.gc = function (items) {
        log.debug('START');
        const context = new Context();
        context.remove(items);

        const result = x.pick(context, 'removedItems', 'removedSize', 'error');
        log.debug('FINISHED', result);

        return result;
    };
}

export default GarbageCollector;
